import styled from 'styled-components/macro'
import MuiTable from '@material-ui/core/Table'

const Table = styled(MuiTable)`
  margin-top: 24px;
  border-collapse: collapse;
`

export default Table
